import { render, staticRenderFns } from "./combien-coute-vraiment-la-creation-dun-site-internet-en-2026.vue?vue&type=template&id=2748429a&"
import script from "./combien-coute-vraiment-la-creation-dun-site-internet-en-2026.vue?vue&type=script&lang=js&"
export * from "./combien-coute-vraiment-la-creation-dun-site-internet-en-2026.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports